module.exports = __webpack_public_path__ + "static/media/icon-send-left.07d2b6ac.svg";